import { IMAGE } from '../elements/assets'

export const METRICS_BAR_V2 = `
  ... on metricsBarV2_Entry {
    id
    typeHandle

    metricsBarMatrix {
      id
      title
      ${ IMAGE }
      text
    }
  }
`